interface WithLogo {
  featuredImageFileUrl: string | null;
  imageList: ({ url: string } | null)[] | null;
}

export function logoUrl(c: WithLogo): string | null {
  if (c.featuredImageFileUrl) return c.featuredImageFileUrl;
  return c.imageList?.find(i => i != null)?.url ?? null;
}
